module.exports = __webpack_public_path__ + "img/m2.ab9a73d5.png";